import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useMaintenanceContext } from "@/contexts/MaintenanceContext";
import { avisoDeManutencaoNoLogin } from "@/modules/maintenance/utils/avisoDeManutencaoNoLogin";

interface FechadaNaManutencaoProps {
  /** Pra onde volta quando a manutenção fecha a tela — o login (interno ou
   * do portal) mostra o aviso grande. */
  destino: "/login" | "/portal/login";
  children: ReactNode;
}

/**
 * Fecha telas públicas de recuperação/ativação durante a manutenção (PR 2,
 * 28/09/2026, decisão do Augusto): `/recuperar-senha`, `/resetar-senha`,
 * `/activate-account`, `/primeiro-acesso` e `/portal/primeiro-acesso`. O
 * backend recusa as APIs delas quando a manutenção trava (e já durante a
 * contagem regressiva o aviso precisa aparecer) — sem esta guarda, a pessoa
 * preenchia um formulário pra tomar erro sem explicação.
 *
 * Aplicado DENTRO de cada página (na exportação default), não no `App.tsx`
 * (arquivo-espinha) — ver o invólucro de cada página guardada.
 */
export function FechadaNaManutencao({ destino, children }: FechadaNaManutencaoProps) {
  const contexto = useMaintenanceContext();
  const aviso = avisoDeManutencaoNoLogin(contexto);

  if (aviso) {
    return <Navigate to={destino} replace />;
  }

  return <>{children}</>;
}
